import './empirefoods2/style';
import FormStructure from './empirefoods2/form_structure';

export default FormStructure;